import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { EmptyChart } from '../../pages/Analytics/EmptyChart';
import { TableHeader } from '../TableHeader';
import { TableWrapper } from '../TableWrapper';

import { ReportsManagerRow } from './ReportsManagerRow';
import { ReportsManagerPagination } from './ReportsManagerPagination';
import { REPORTS_MANAGER_SORT } from '../../../store/reducers/reportsManager';
import { reportsManagerColumns } from './consts';

import styles from './ReportsManagerTable.module.scss';
import tableStyles from '../reports/ReportTable.module.scss';
import { buildStyleFunctions } from '../reports/reportsColumnNames/utils';

export function ReportsManagerTable() {
  const dispatch = useDispatch();
  const {
    data,
    table: { sort },
  } = useSelector((state) => state.reportsManager);
  const { column: sortedBy, direction: sortDirection } = sort;

  return (
    <div className={styles.reportTableWrapper}>
      <TableWrapper hasExpandedRow={false} className={cn(styles.reportsManagerTable, tableStyles.reportTable)}>
        <TableHeader
          columns={Object.keys(reportsManagerColumns)}
          columnsData={buildStyleFunctions(reportsManagerColumns, styles)}
          additionalStyles={styles}
          sort={{
            sortedBy: sortedBy,
            direction: sortDirection,
            initialColumn: 'createdAt',
            onSortBy: (column, direction) => {
              dispatch({
                type: REPORTS_MANAGER_SORT,
                payload: { column, direction },
              });
            },
          }}
        />

        <tbody>
          {data.length > 0 ? (
            data.map((record) => {
              const keyParts = [record.type, record.createdAt];
              if (record.reportFile) keyParts.push(record.reportFile.name);
              return <ReportsManagerRow key={keyParts.join('-')} row={record} />;
            })
          ) : (
            <tr>
              <td colSpan={6}>
                <EmptyChart title="No reports to display" />
              </td>
            </tr>
          )}
        </tbody>
      </TableWrapper>

      <ReportsManagerPagination />
    </div>
  );
}
